export default __webpack_public_path__ + "e7cd874c92b20f0e7add45506f16fb6a.jpg";